// extracted by mini-css-extract-plugin
export default {"tools":"PageSend_tools__bS08m","body":"PageSend_body__Ury3m","button":"PageSend_button__0mMed"};